import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { actions } from '../constants/free_mobile_fitting_light_box/actions';

class ClearanceInfoLightBoxClass extends ReduceStore {
  getInitialState() {
    return {
      visible: false,
      isAddToCart: false,
      isFittingStation: false,
    };
  }

  reduce(state, { source, action }) {
    const { type, payload } = action;

    if (source === ACTION_TYPES.INFO_LIGHT_BOX_ACTION) {
      switch (type) {
        case actions.SHOW:
          if (!state.visible) {
            state.visible = true;

            if (payload) {
              state.isAddToCart = payload.isAddToCart === true;
              state.isFittingStation = payload.isFittingStation === true;
            }
            this.__emitChange();
          }
          break;

        case actions.HIDE:
          if (state.visible) {
            state.visible = false;
            state.isAddToCart = false;
            state.isFittingStation = false;
            this.__emitChange();
          }
          break;
        default:
          if (state.visible) {
            state.visible = false;
            state.isAddToCart = false;
            state.isFittingStation = false;
            this.__emitChange();
          }
          break;
      }
    }

    return state;
  }
}

const ClearanceInfoLightBoxStore = new ClearanceInfoLightBoxClass(Dispatcher);
export { ClearanceInfoLightBoxStore };
